{
  "version": 1,
  "asset_id": "32551817-a77c-420b-b0e0-1d483209875b",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/32551817-a77c-420b-b0e0-1d483209875b/bypass-weight-loss-graph.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/32551817-a77c-420b-b0e0-1d483209875b/bypass-weight-loss-graph.webp",
  "original_filename": "bypass-weight-loss-graph.webp",
  "size": 40514,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:23:05Z"
}
